import React from 'react';
import { IGoodReceiveItem } from '@/interfaces/goodReceive';
import TableComponent from '@/components/table';
import { formatDate, formatNumber } from '@/utils/dataUtils';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { TableProps } from 'antd';

interface IProps {
  items: IGoodReceiveItem[];
}

const GoodReceiveTable = ({ items }: IProps) => {
  dayjs.extend(relativeTime);

  const columns: TableProps<IGoodReceiveItem>['columns'] = [
    {
      title: 'ITEM CODE',
      dataIndex: 'productCode',
      key: 'productCode',
      align: 'center',
      width: 120,
    },
    {
      title: 'ITEM NAME',
      dataIndex: 'productName',
      key: 'productName',
      className: 'font-bold text-green-700',
    },
    {
      title: 'LOT NUMBER',
      dataIndex: 'lotNumber',
      key: 'lotNumber',
      className: 'font-bold',
      align: 'center',
    },
    {
      title: 'Expired Date',
      dataIndex: 'expiredDate',
      key: 'expiredDate',
      align: 'center',
      render: _ => formatDate(_),
    },
    {
      title: 'PACKAGE QTY.',
      dataIndex: 'quantity',
      key: 'quantity',
      className: 'font-bold',
      align: 'center',
      render: _ => formatNumber(_),
    },
    {
      title: 'PACKAGE UNIT.',
      dataIndex: 'packageUnitId',
      key: 'packageUnitId',
      className: 'font-bold',
      align: 'center',
    },
    {
      title: 'BASE QTY.',
      dataIndex: 'quantity',
      key: 'quantity',
      className: 'font-bold',
      align: 'center',
      render: (_, rec) => formatNumber(_ * rec.conversion),
    },
    {
      title: 'BASE UNIT.',
      dataIndex: 'baseUnitId',
      key: 'baseUnitId',
      className: 'font-bold',
      align: 'center',
    },
  ];

  return (
    <div className="flex flex-col gap-3">
      <TableComponent<IGoodReceiveItem>
        columns={columns}
        criteria={undefined}
        data={{ data: items || [], totalRecords: items?.length || 0 }}
        loading={false}
        onTableChange={undefined}
        showPagination={false}
      />
    </div>
  );
};

export default GoodReceiveTable;
